import { create } from "zustand";

type HudOverlayState = {
    openId: string | null;
    open: (id: string) => void;
    close: () => void;
    toggle: (id: string) => void;
    isOpen: (id: string) => boolean;
};

export const useHudOverlay = create<HudOverlayState>((set, get) => ({
    openId: null,
    open: (id) => set({ openId: id }),
    close: () => set({ openId: null }),
    toggle: (id) => {
        const { openId } = get();
        set({ openId: openId === id ? null : id });
    },
    isOpen: (id) => get().openId === id,
}));
